// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import type {T_Formatter} from './types.js';


type T_TdColorProps = {
  color   : string,
  smile_if: boolean
}


function TdColor(props: T_TdColorProps) {
  return (
    <td className='esc_color'>
      <div style={{backgroundColor: props.color, border: (props.smile_if ? '2px solid black' : '0')}}>
        &nbsp;
      </div>
    </td>
  );
}



type T_TrProps = {
  color   : string,
  rel     : string,
  range   : Array<number>,
  snum    : T_Formatter,
  hilight : boolean,
  smile_on: number,
  enabled : boolean,
  index   : number,
  
  on_click: (ev: SyntheticMouseEvent<*>) => void,
};




class TrExtreme extends Component<T_TrProps> {
  click: (ev: SyntheticMouseEvent<*>) => void;
  
  
  constructor(props: T_TrProps) {
    super(props);
    
    this.click = this.click.bind(this);
  }
  
  
  
  click(ev: SyntheticMouseEvent<*>): void {
    if (this.props.enabled) {
      this.props.on_click(ev);
    }
  }
  
  
  
  render() {
    const {props}    = this,
          sty_gen    = props.enabled ? {cursor: 'pointer'} : {},
          cl_enabled = props.enabled ? '' : 'row_disabled';
    
    return (
      <tr onClick={this.click} style={sty_gen} className={props.hilight ? 'tr_ext_hilight' : 'tr_ext_white'}>
        <TdColor
          color={props.color}
          smile_if={
            props.rel.indexOf('<') === 0 ?
              (props.smile_on <= props.range[0])
            :
              (props.rel.indexOf('>') === 0 ? props.smile_on >= props.range[0] : false)
          }
        />
        
        <td colSpan={3} className={`tr_ext_label ${cl_enabled}`}>
          {props.rel} {props.snum(props.range[0])}
        </td>
      </tr>
    );
  }
}






class TrMiddle extends Component<T_TrProps> {
  click: (ev: SyntheticMouseEvent<*>) => void;
  
  
  constructor(props: T_TrProps) {
    super(props);
    
    this.click = this.click.bind(this);
  }
  
  
  
  click(ev: SyntheticMouseEvent<*>) {
    if (this.props.enabled) {
      this.props.on_click(ev);
    }
  }
  
  
  
  render() {
    const cl_mid     = this.props.hilight ? 'tr_esc_hilight' : 'tr_esc_white',
          cl_enabled = this.props.enabled ? '' : 'row_disabled',
          num        = {'data-num': this.props.index},
          sty_gen    = this.props.enabled ? {cursor: 'pointer'} : {};
    
    return (
      <tr onClick={this.click} className={cl_mid} style={sty_gen} {...num}>
        <TdColor
          color={this.props.color}
          smile_if={this.props.range[0] <= this.props.smile_on && this.props.smile_on <= this.props.range[1]}
        />
        <td className={`esc_num ${cl_enabled}`}>{this.props.snum(this.props.range[0])}</td>
        <td className={`esc_sep ${cl_enabled}`}>-</td>
        <td className={`esc_num ${cl_enabled}`}>{this.props.snum(this.props.range[1])}</td>
      </tr>
    );
  }
}



export type T_ReadEscalaRow = {
  color: string,
  rel  : string,
  range: Array<number>
};


export type T_ReadEscala = {
  elem        : string,
  unit        : string,
  rows        : Array<T_ReadEscalaRow>,
  sel_changed?: (hilight_top: boolean, hilight_middle: Array<number>, hilight_bottom: boolean) => void,
  name_escala : string,
  smile_on    : number,
  lim         : ?[number, number],
  snum        : T_Formatter
};


type T_TablaEscalaState = {
  hilight_middle: Array<number>;
  hilight_top   : boolean,
  hilight_bottom: boolean
};



export default class TablaEscala extends Component<T_ReadEscala, T_TablaEscalaState> {
  click_top   : (ev: SyntheticMouseEvent<*>) => void;
  click_bottom: (ev: SyntheticMouseEvent<*>) => void;
  click_middle: (ev: SyntheticMouseEvent<*>) => void;
  
  
  
  constructor(props: T_ReadEscala) {
    super(props);
    
    this.state = {
      hilight_middle: [],
      hilight_top   : false,
      hilight_bottom: false
    };
    
    this.click_top    = this.click_top.bind(this);
    this.click_bottom = this.click_bottom.bind(this);
    this.click_middle = this.click_middle.bind(this);
  }
  
  
  
  reset_hilight(): void {
    this.setState({
      hilight_middle: [],
      hilight_top   : false,
      hilight_bottom: false
    });
  }
  
  
  
  componentDidUpdate(prevProps: T_ReadEscala, prevState: T_TablaEscalaState): void {
    const inversed = ! _.isEqual(prevProps.rows.map(row => row.color), this.props.rows.map(row => row.color));
    
    if (prevProps.rows.length !== this.props.rows.length || prevProps.name_escala !== this.props.name_escala || inversed) {
      this.reset_hilight();
    }
    
    if ((this.props.sel_changed != null && _.isFunction(this.props.sel_changed)) &&
        (prevState.hilight_top    !== this.state.hilight_top    ||
         prevState.hilight_bottom !== this.state.hilight_bottom || 
         ! _.isEqual(prevState.hilight_middle, this.state.hilight_middle))) {
      this.props.sel_changed(this.state.hilight_top, this.state.hilight_middle, this.state.hilight_bottom);
    }
  }
  
  
  
  total_selected(): number {
    let num = 0;
    
    if (this.state.hilight_top) {
      num++;
    }
    
    if (this.state.hilight_bottom) {
      num++;
    }

    return num + this.state.hilight_middle.length;
  }
  
  
  
  has_multi_selection(): bool {
    return this.total_selected() > 1;
  }
  
  
  
  has_selection(): bool {
    return this.state.hilight_top || this.state.hilight_bottom || this.state.hilight_middle.length > 0;
  }
  
  
  
  has_single_selection(): bool {
    return this.total_selected() === 1;
  }
  
  
  
  click_middle(ev: SyntheticMouseEvent<*>): void {
    const num         = parseInt(ev.currentTarget.dataset.num, 10),
          is_selected = _.includes(this.state.hilight_middle, num);
    
    if (this.props.sel_changed != null) {
      if (! ev.shiftKey) {
        this.setState({
          hilight_middle: this.has_multi_selection() ? [num] :
                            (this.has_single_selection() ? (is_selected ? [] : [num]) : [num]),
          hilight_top   : false,
          hilight_bottom: false
        });
      }
      else if (is_selected) {
        this.setState({
          hilight_middle: _.cloneDeep(this.state.hilight_middle).filter(xi => xi !== num)
        });
      }
      else {
        const hilight_middle = _.cloneDeep(this.state.hilight_middle);
        
        hilight_middle.push(num);
        
        this.setState({hilight_middle});
      }
    }
  }
  
  
  
  click_top(ev: SyntheticMouseEvent<*>): void {
    if (this.props.sel_changed != null) {
      if (ev.shiftKey) {
        this.setState({hilight_top: ! this.state.hilight_top});
      }
      else {
        this.setState({
          hilight_top: this.has_multi_selection() ? true : (! this.state.hilight_top),
          hilight_middle: [],
          hilight_bottom: false
        });
      }
    }
  }
  
  
    
  click_bottom(ev: SyntheticMouseEvent<*>): void {
    if (this.props.sel_changed != null) {
      if (ev.shiftKey) {
        this.setState({hilight_bottom: ! this.state.hilight_bottom});
      }
      else {
        this.setState({
          hilight_bottom: this.has_multi_selection() ? true : (! this.state.hilight_bottom),
          hilight_top: false,
          hilight_middle: []
        });
      }
    }
  }
  
  
  
  get_color_of(value: number): string {
    const {rows} = this.props,
          e1     = this.props.rows[0],
          e2     = _.last(this.props.rows);
    
    if (e1.rel.indexOf('<') === 0 && value <= e1.range[0]) {
      return e1.color;
    }
    else if (e1.rel.indexOf('>') === 0 && value >= e1.range[0]) {
      return e1.color;
    }
    if (e2.rel.indexOf('<') === 0 && value <= e2.range[0]) {
      return e2.color;
    }
    else if (e2.rel.indexOf('>') === 0 && value >= e2.range[0]) {
      return e2.color;
    }
    else {
      const row = rows.filter(Row => Row.range[0] <= value && value <= Row.range[1]);
      
      return row.length > 0 ? row[0].color : '#000000';
    }
  }
  
  
  
  render() {
    const {props}     = this,
          has_click   = props.sel_changed != null,
          png_min     = props.lim != null && props.lim.length > 0 ? props.lim[0] : -1,
          png_max     = props.lim != null && props.lim.length > 1 ? props.lim[1] : -1,
          esc_min     = props.rows[0].range[0],
          esc_max     = _.last(props.rows).range[0],
          no_png_lims = props.lim == null,
          esc_inv     = props.rows[0].rel.indexOf('<') === 0;
    
    return (
      <div className='TablaEscala'>
        <b>
          {props.elem}
        </b>
        
        {props.unit &&
          <span style={{width: '100%', marginLeft: 2}}>
            {' '} {props.unit}
          </span>
        }
        
        <table className='esc_table'>
          <tbody>
            <TrExtreme
              {...props.rows[0]}
              on_click={this.click_top}
              hilight={this.state.hilight_top}
              smile_on={this.props.smile_on}
              snum={this.props.snum}
              index={0}
              enabled={
                no_png_lims ?
                  has_click
                :
                  (png_min <= esc_min && esc_min <= png_max) ||
                  (esc_inv ?
                    png_max < Math.min(esc_min, esc_max)
                  : 
                    png_min > Math.max(esc_min, esc_max))
              }
            />
            
            {_.tail(_.initial(props.rows)).map((row, num) => {
              const enabled = no_png_lims ? has_click :
                               ((png_min <= row.range[0] && row.range[0] <= png_max) ||
                                (png_min <= row.range[1] && row.range[1] <= png_max) ||
                               ((row.range[0] <= png_min && png_min <= row.range[1]) ||
                                (row.range[0] <= png_max && png_max <= row.range[1])));
              
              return (
                <TrMiddle
                  {...row}
                  on_click={this.click_middle}
                  hilight={_.includes(this.state.hilight_middle, num)}
                  smile_on={this.props.smile_on}
                  snum={this.props.snum}
                  enabled={enabled}
                  key={num}
                  index={num}
                />
              );
            })}
            
            <TrExtreme
              {..._.last(props.rows)}
              on_click={this.click_bottom}                     // FIXME: IMPLEMENTA EL MISMO CHEQUEO DE Enabled
              hilight={this.state.hilight_bottom}              // QUE EN EL PRIMER TrExtreme
              smile_on={this.props.smile_on}
              snum={this.props.snum}
              index={props.rows.length - 1}
              enabled={no_png_lims ? has_click : png_min <= esc_max && esc_max <= png_max}
            />
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TablaEscala.jsx